"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBSOCKET_RESPONSE_EXPECTED = void 0;
exports.WEBSOCKET_RESPONSE_EXPECTED = 'WEBSOCKET_RESPONSE_EXPECTED';
